import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function WhoIsThisForSection() {
  const painPoints = ['Llega la quincena y ya sabes que no va a alcanzar', 'Te da ansiedad revisar tu cuenta bancaria', 'No sabes exactamente a dónde se va tu dinero', 'Quieres ahorrar, pero siempre surge algo', 'Sientes que trabajas… pero nunca avanzas'];
  return <section className="w-full py-20 bg-white" data-id="element-307">
      <div className="max-w-4xl mx-auto px-6" data-id="element-308">
        <div className="text-center mb-12" data-id="element-309">
          <h2 className="font-serif text-4xl lg:text-5xl text-navy-900 mb-6" data-id="element-310">
            Si esto te suena familiar, este libro es para ti:
          </h2>
        </div>

        <div className="bg-gradient-to-br from-emerald-50 to-cyan-50 rounded-3xl shadow-xl p-8 lg:p-12 mb-8" data-id="element-311">
          <div className="space-y-5" data-id="element-312">
            {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-313">
                <CheckCircleIcon className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-1" data-id="element-314" />
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-315">{point}</p>
              </div>)}
          </div>
        </div>

        <div className="text-center space-y-6 bg-navy-900 text-white rounded-3xl p-8 lg:p-12" data-id="element-316">
          <p className="text-xl text-gray-300" data-id="element-317">
            No es flojera. No es falta de esfuerzo. Y no es que seas mala con el
            dinero.
          </p>

          <h3 className="font-serif text-3xl lg:text-4xl text-emerald-400" data-id="element-318">
            La verdad que nadie te dijo
          </h3>

          <p className="text-2xl font-bold" data-id="element-319">El problema no es cuánto ganas.</p>

          <p className="text-2xl font-bold text-emerald-400" data-id="element-320">
            Es que nadie te enseñó a manejar lo que ya tienes.
          </p>

          <div className="pt-6" data-id="element-321">
            <p className="text-lg text-gray-300 mb-4" data-id="element-322">
              Vivir sin un sistema claro te mantiene:
            </p>
            <ul className="space-y-3 text-left max-w-md mx-auto" data-id="element-323">
              <li className="flex items-start gap-3" data-id="element-324">
                <span className="text-red-400 mt-1" data-id="element-325">•</span>
                <span data-id="element-326">En estrés constante</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-327">
                <span className="text-red-400 mt-1" data-id="element-328">•</span>
                <span data-id="element-329">En modo emergencia</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-330">
                <span className="text-red-400 mt-1" data-id="element-331">•</span>
                <span data-id="element-332">Reaccionando en lugar de eligiendo</span>
              </li>
            </ul>
            <p className="text-xl font-bold text-emerald-400 mt-6" data-id="element-333">
              Y así es imposible avanzar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}